import { topicsMapBySubject } from "./topicsMapBySubject";

import { catopicsMapBySubject } from "./ca-topics/catopicsMapBySubject";
import { aktopicsMapBySubject } from "./ak-topics/aktopicsMapBySubject";
import { altopicsMapBySubject } from "./al-topics/altopicsMapBySubject";
import { artopicsMapBySubject } from "./ar-topics/artopicsMapBySubject";
import { aztopicsMapBySubject } from "./az-topics/aztopicsMapBySubject";
import { cttopicsMapBySubject } from "./ct-topics/cttopicsMapBySubject";
import { dctopicsMapBySubject } from "./dc-topics/dctopicsMapBySubject";
import { fltopicsMapBySubject } from "./fl-topics/fltopicsMapBySubject";
import { gatopicsMapBySubject } from "./ga-topics/gatopicsMapBySubject";
import { hitopicsMapBySubject } from "./hi-topics/hitopicsMapBySubject";
import { idtopicsMapBySubject } from "./id-topics/idtopicsMapBySubject";
import { iltopicsMapBySubject } from "./il-topics/iltopicsMapBySubject";
import { intopicsMapBySubject } from "./in-topics/intopicsMapBySubject";
import { iatopicsMapBySubject } from "./ia-topics/iatopicsMapBySubject";
import { kstopicsMapBySubject } from "./ks-topics/kstopicsMapBySubject";
import { kytopicsMapBySubject } from "./ky-topics/kytopicsMapBySubject";
import { latopicsMapBySubject } from "./la-topics/latopicsMapBySubject";
import { metopicsMapBySubject } from "./me-topics/metopicsMapBySubject";
import { mdtopicsMapBySubject } from "./md-topics/mdtopicsMapBySubject";
import { matopicsMapBySubject } from "./ma-topics/matopicsMapBySubject";
import { mntopicsMapBySubject } from "./mn-topics/mntopicsMapBySubject";
import { mitopicsMapBySubject } from "./mi-topics/mitopicsMapBySubject";
import { mstopicsMapBySubject } from "./ms-topics/mstopicsMapBySubject";
import { motopicsMapBySubject } from "./mo-topics/motopicsMapBySubject";
import { mttopicsMapBySubject } from "./mt-topics/mttopicsMapBySubject";
import { netopicsMapBySubject } from "./ne-topics/netopicsMapBySubject";
import { nvtopicsMapBySubject } from "./nv-topics/nvtopicsMapBySubject";
import { njtopicsMapBySubject } from "./nj-topics/njtopicsMapBySubject";
import { nmtopicsMapBySubject } from "./nm-topics/nmtopicsMapBySubject";
import { nytopicsMapBySubject } from "./ny-topics/nytopicsMapBySubject";
import { nctopicsMapBySubject } from "./nc-topics/nctopicsMapBySubject";
import { ndtopicsMapBySubject } from "./nd-topics/ndtopicsMapBySubject";
import { ohtopicsMapBySubject } from "./oh-topics/ohtopicsMapBySubject";
import { oktopicsMapBySubject } from "./ok-topics/oktopicsMapBySubject";
import { ortopicsMapBySubject } from "./or-topics/ortopicsMapBySubject";
import { patopicsMapBySubject } from "./pa-topics/patopicsMapBySubject";
import { ritopicsMapBySubject } from "./ri-topics/ritopicsMapBySubject";
import { sctopicsMapBySubject } from "./sc-topics/sctopicsMapBySubject";
import { sdtopicsMapBySubject } from "./sd-topics/sdtopicsMapBySubject";
import { tntopicsMapBySubject } from "./tn-topics/tntopicsMapBySubject";
import { txtopicsMapBySubject } from "./tx-topics/txtopicsMapBySubject";
import { uttopicsMapBySubject } from "./ut-topics/uttopicsMapBySubject";
import { vttopicsMapBySubject } from "./vt-topics/vttopicsMapBySubject";
import { vatopicsMapBySubject } from "./va-topics/vatopicsMapBySubject";
import { watopicsMapBySubject } from "./wa-topics/watopicsMapBySubject";
import { wvtopicsMapBySubject } from "./wv-topics/wvtopicsMapBySubject";
import { witopicsMapBySubject } from "./wi-topics/witopicsMapBySubject";
import { wytopicsMapBySubject } from "./wy-topics/wytopicsMapBySubject";

export const stateTopicsMap = {
  topicsMapBySubject, // default
  ca: catopicsMapBySubject,
  ak: aktopicsMapBySubject,
  al: altopicsMapBySubject,
  ar: artopicsMapBySubject,
  az: aztopicsMapBySubject,
  ct: cttopicsMapBySubject,
  dc: dctopicsMapBySubject,
  fl: fltopicsMapBySubject,
  ga: gatopicsMapBySubject,
  hi: hitopicsMapBySubject,
  id: idtopicsMapBySubject,
  il: iltopicsMapBySubject,
  in: intopicsMapBySubject,
  ia: iatopicsMapBySubject,
  ks: kstopicsMapBySubject,
  ky: kytopicsMapBySubject,
  la: latopicsMapBySubject,
  me: metopicsMapBySubject,
  md: mdtopicsMapBySubject,
  ma: matopicsMapBySubject,
  mn: mntopicsMapBySubject,
  mi: mitopicsMapBySubject,
  ms: mstopicsMapBySubject,
  mo: motopicsMapBySubject,
  mt: mttopicsMapBySubject,
  ne: netopicsMapBySubject,
  nv: nvtopicsMapBySubject,
  nj: njtopicsMapBySubject,
  nm: nmtopicsMapBySubject,
  ny: nytopicsMapBySubject,
  nc: nctopicsMapBySubject,
  nd: ndtopicsMapBySubject,
  oh: ohtopicsMapBySubject,
  ok: oktopicsMapBySubject,
  or: ortopicsMapBySubject,
  pa: patopicsMapBySubject,
  ri: ritopicsMapBySubject,
  sc: sctopicsMapBySubject,
  sd: sdtopicsMapBySubject,
  tn: tntopicsMapBySubject,
  tx: txtopicsMapBySubject,
  ut: uttopicsMapBySubject,
  vt: vttopicsMapBySubject,
  va: vatopicsMapBySubject,
  wa: watopicsMapBySubject,
  wv: wvtopicsMapBySubject,
  wi: witopicsMapBySubject,
  wy: wytopicsMapBySubject,
};
